import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withFormik } from 'formik';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

import { capfl } from 'common/utils';
import Button from 'common/components/styleguide/Button';
import Icon from 'common/components/styleguide/Icon';
import Modal from 'common/components/_partials/modal/mobilonline/index';

import {
  PRODUCT_SOFT_HOOK_TYPE,
  PRODUCT_DICOUNT_HOOK_TYPE
} from 'common/constants/ProductConstants';
import CheckboxGroup from 'common/components/styleguide/form/CheckboxGroup';
import RadioGroup from 'common/components/styleguide/form/RadioGroup';
import SelectGroup from 'common/components/styleguide/form/SelectCustomGroup';
import { addToCart } from 'common/actions/CartActions';
import Image from 'common/components/_base/Image';
import Price from 'common/components/_base/Price';

const ERROR_NAME_NOTHING_PICKED = 'nothing_picked';

const S = {};
S.HookItem = styled.section`
  border: 1px solid #eee;
  margin-bottom: 10px;
`;

S.HookItemInner = styled.section`
  display: flex;
  align-items: center;
  padding: 10px;
`;

S.HookItemBottom = styled.section`
  padding: 10px;
  padding-top: 0;
`;

S.HookItemBottomSelectGroup = styled(SelectGroup)`
  margin: 0;
`;

S.HookItemImageWithText = styled.section`
  display: flex;
  align-items: center;
`;

S.SoftHookItemProducts = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

S.HookItemImage = styled.section`
  width: 60px;
  height: 60px;
  overflow: hidden;
  flex: 0 0 60px;
  margin-right: 10px;
`;

S.CheckboxWrapper = styled.section``;

S.CheckboxGroup = styled(CheckboxGroup)`
  margin: 0;
`;

S.RadioGroup = styled(RadioGroup)`
  margin: 0;
`;

S.HookItemText = styled.section`
  flex: 1 0 0;
`;

S.HookItemName = styled.section`
  font-size: 0.75em;
  font-weight: 600;
  margin-bottom: 2px;
`;

S.HookItemPrice = styled(Price)`
  margin: 0;
`;

const DickountHooks = ({ hooks, values, errors, touched, setFieldValue, setFieldTouched, t }) => {
  return (
    <section>
      {_.map(hooks, hook => {
        const hooksNameBase = 'discount_hook';
        const hooksName = hooksNameBase + '.' + hook.id;
        const { hookedProducts } = hook;
        if (hookedProducts) {
          return _.map(hookedProducts, product => {
            const {
              id: productId,
              name: productName,
              store,
              photo,
              finalPrice,
              finalPriceWithoutDPH,
              price
            } = product;
            const key = 'hooked-product-' + productId;
            const id = key;
            const selectName = id + '-store';
            let isChecked = false;
            let checkedValues = _.get(values, hooksName, false);
            if (checkedValues) {
              if (_.isArray(checkedValues)) {
                isChecked = _.indexOf(checkedValues, _.toString(productId)) !== -1;
              } else {
                isChecked = checkedValues === _.toString(productId);
              }
            }
            return (
              <S.HookItem key={key}>
                <S.HookItemInner>
                  <S.CheckboxWrapper>
                    <S.CheckboxGroup
                      checkboxProps={{
                        setValueChecked: isChecked,
                        id: id,
                        name: hooksName,
                        value: productId,
                        setFieldValue,
                        setFieldTouched,
                        values
                      }}
                      error={touched[hooksName] && errors[hooksName] ? errors[hooksName] : ''}
                    />
                  </S.CheckboxWrapper>
                  <S.HookItemImageWithText>
                    <S.HookItemImage>
                      <Image {...photo} size="120x120.png" />
                    </S.HookItemImage>
                    <S.HookItemText>
                      <S.HookItemName>{productName}</S.HookItemName>
                      <S.HookItemPrice
                        showDiscount={false}
                        showWithoutVat={false}
                        finalPrice={finalPrice}
                        finalPriceWithoutDPH={finalPriceWithoutDPH}
                        price={price}
                      />
                    </S.HookItemText>
                  </S.HookItemImageWithText>
                </S.HookItemInner>
                {isChecked ? (
                  <S.HookItemBottom>
                    <S.HookItemBottomSelectGroup
                      selectProps={{
                        id: selectName,
                        name: selectName,
                        value: values[selectName] ? values[selectName] : null,
                        touched: touched[selectName],
                        options: _.map(store, item => {
                          return { value: item.id, label: item.name };
                        }),
                        setFieldValue,
                        setFieldTouched
                      }}
                      error={touched[selectName] && errors[selectName] ? errors[selectName] : ''}
                      label={t('size')}
                    />
                  </S.HookItemBottom>
                ) : (
                  ''
                )}
              </S.HookItem>
            );
          });
        }
        return null;
      })}
    </section>
  );
};

const SoftHooks = ({ hooks, values, errors, touched, setFieldValue, setFieldTouched, t }) => {
  return (
    <section>
      {_.map(hooks, hook => {
        const { hookedProducts } = hook;
        const hooksName = 'soft_hook';
        const key = 'soft-hook-' + hook.id;
        const id = key;
        let isChecked = false;
        let checkedValues = _.get(values, hooksName, false);
        if (checkedValues) {
          if (_.isArray(checkedValues)) {
            isChecked = _.indexOf(checkedValues, _.toString(hook.id)) !== -1;
          } else {
            isChecked = checkedValues === _.toString(hook.id);
          }
        }
        if (hookedProducts) {
          return (
            <S.HookItem key={key}>
              <S.HookItemInner>
                <S.CheckboxWrapper>
                  <S.RadioGroup
                    radioProps={{
                      setValueChecked: { value: hook.id, isChecked },
                      id: id,
                      name: hooksName,
                      options: [
                        {
                          value: hook.id,
                          label: ''
                        }
                      ],
                      setFieldValue,
                      setFieldTouched,
                      values
                    }}
                  />
                </S.CheckboxWrapper>
                <S.SoftHookItemProducts>
                  {_.map(hookedProducts, product => {
                    const {
                      id: productId,
                      name: productName,
                      store,
                      photo,
                      finalPrice,
                      finalPriceWithoutDPH,
                      price
                    } = product;
                    const selectName = 'hooked-product-' + productId + '-store';
                    return (
                      <section key={'soft-hook-product-' + productId}>
                        <S.HookItemImageWithText>
                          <S.HookItemImage>
                            <Image {...photo} size="120x120.png" />
                          </S.HookItemImage>
                          <S.HookItemText>
                            <S.HookItemName>{productName}</S.HookItemName>
                            <S.HookItemPrice
                              showDiscount={false}
                              showWithoutVat={false}
                              finalPrice={finalPrice}
                              finalPriceWithoutDPH={finalPriceWithoutDPH}
                              price={price}
                            />
                          </S.HookItemText>
                        </S.HookItemImageWithText>
                        {isChecked ? (
                          <S.HookItemBottom>
                            <S.HookItemBottomSelectGroup
                              selectProps={{
                                id: selectName,
                                name: selectName,
                                value: values[selectName] ? values[selectName] : null,
                                touched: touched[selectName],
                                options: _.map(store, item => {
                                  return { value: item.id, label: item.name };
                                }),
                                setFieldValue,
                                setFieldTouched
                              }}
                              error={
                                touched[selectName] && errors[selectName] ? errors[selectName] : ''
                              }
                              label={t('size')}
                            />
                          </S.HookItemBottom>
                        ) : (
                          ''
                        )}
                      </section>
                    );
                  })}
                </S.SoftHookItemProducts>
              </S.HookItemInner>
            </S.HookItem>
          );
        }
        return null;
      })}
    </section>
  );
};

S.DicountHooksWrapper = styled.section`
  padding: 20px 20px 10px 20px;
`;

S.SoftHooksWrapper = styled.section`
  padding: 10px 20px;
`;

S.HooksTitle = styled.div`
  font-size: 0.86em;
  font-weight: 600;
  margin-bottom: 10px;
`;

S.ButtonWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  border-top: 1px solid #eee;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
`;

S.ButtonCart = styled(Button)`
  min-width: 160px;
  text-transform: uppercase;
  margin-right: 10px;
`;

S.ErrorBar = styled.section`
  padding: 10px;
  text-align: center;
  font-weight: 600;
  font-size: 0.86em;
  color: ${({ theme }) => _.get(theme, 'colors.danger', 'red')};
`;

class DetailHooksForm extends Component {
  render() {
    const {
      data,
      values,
      errors,
      touched,
      handleSubmit,
      setFieldValue,
      setFieldTouched,
      isSubmitting,
      isValid,
      t
    } = this.props;
    if (data) {
      const discountHooks = _.filter(data, item => item.type === PRODUCT_DICOUNT_HOOK_TYPE);
      const softHooks = _.filter(data, item => item.type === PRODUCT_SOFT_HOOK_TYPE);
      return (
        <Modal modalId="product_hooks" title={capfl(t('you can add these products'))}>
          <form onSubmit={handleSubmit}>
            <S.DicountHooksWrapper>
              <S.HooksTitle>{capfl(t('discount hooks'))}</S.HooksTitle>
              <DickountHooks
                hooks={discountHooks}
                values={values}
                errors={errors}
                touched={touched}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                t={t}
              />
            </S.DicountHooksWrapper>
            <S.SoftHooksWrapper>
              <S.HooksTitle>{capfl(t('soft hooks'))}</S.HooksTitle>
              <SoftHooks
                hooks={softHooks}
                values={values}
                errors={errors}
                touched={touched}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                t={t}
              />
            </S.SoftHooksWrapper>
            {errors[ERROR_NAME_NOTHING_PICKED] ? (
              <S.ErrorBar>{errors[ERROR_NAME_NOTHING_PICKED]}</S.ErrorBar>
            ) : (
              ''
            )}
            <S.ButtonWrapper>
              <S.ButtonCart type="submit" disabled={!isValid || isSubmitting}>
                {isSubmitting ? <Icon className="nc-circle-02-1" /> : capfl(t('add to cart'))}
              </S.ButtonCart>
            </S.ButtonWrapper>
          </form>
        </Modal>
      );
    }
    return null;
  }
}

const formikEnhancer = withFormik({
  enableReinitialize: true,
  mapPropsToValues: props => {
    return {
      discount_hook: {},
      soft_hook: null
    };
  },
  handleSubmit: async (values, { props, setSubmitting, setFieldError, setFieldTouched }) => {
    const { t, data } = props;
    const { addHookedProductsToCart } = props;
    const { discount_hook, soft_hook } = values;
    let isValid = true;
    const items = [];
    if (!_.isEmpty(discount_hook)) {
      _.each(discount_hook, (productIds, hookId) => {
        if (_.isArray(productIds)) {
          _.each(productIds, productId => {
            const item = { productId, hookId, count: 1 };
            const field = 'hooked-product-' + productId + '-store';
            const productStore = values[field];
            if (productStore) {
              item.sizeId = productStore.value;
            } else {
              setFieldTouched(field, true, false);
              setFieldError(field, capfl(t('please select size')));
              isValid = false;
            }
            items.push(item);
          });
        } else {
          if (!_.isEmpty(productIds)) {
            const item = {
              productId: productIds,
              productHookId: hookId,
              count: 1
            };
            const field = 'hooked-product-' + productIds + '-store';
            const productStore = values[field];
            if (productStore) {
              item.sizeId = productStore.value;
            } else {
              setFieldTouched(field, true, false);
              setFieldError(field, capfl(t('please select size')));
              isValid = false;
            }
            items.push(item);
          }
        }
      });
    }
    if (!_.isEmpty(soft_hook)) {
      const softHook = _.find(
        data,
        item => item.type === PRODUCT_SOFT_HOOK_TYPE && _.toString(item.id) === soft_hook
      );
      if (softHook) {
        const { hookedProducts } = softHook;
        _.each(hookedProducts, product => {
          const item = { productId: product.id, productHookId: softHook.id, count: 1 };
          const field = 'hooked-product-' + product.id + '-store';
          const productStore = values[field];
          if (productStore) {
            item.sizeId = productStore.value;
          } else {
            setFieldTouched(field, true, false);
            setFieldError(field, capfl(t('please select size')));
            isValid = false;
          }
          items.push(item);
        });
      }
    }
    if (_.isEmpty(items)) {
      setFieldError(ERROR_NAME_NOTHING_PICKED, capfl(t('please add one product')));
      isValid = false;
    }
    if (isValid) {
      addHookedProductsToCart(items);
    }
    setSubmitting(false);
  }
});

const DetailHooksFrom = formikEnhancer(DetailHooksForm);

const mapDispatchToProps = dispatch => {
  return {
    addHookedProductsToCart: items => {
      dispatch(addToCart(items));
    }
  };
};

const DetailHooksFromConnected = connect(
  undefined,
  mapDispatchToProps
)(DetailHooksFrom);

export default withTranslation()(DetailHooksFromConnected);
